import { Text, Title } from "@clipboard-health/ui-components";
import { DialogContent, Stack } from "@mui/material";
import { Button } from "@src/appV2/redesign/components/Button";
import { DialogFooter } from "@src/appV2/redesign/components/DialogFooter";
import { UnverifiedBadgeCounter } from "@src/appV2/redesign/WorkBadges/components/Policy/UnverifiedBadgeCounter";

export interface SkippedBadgeVerificationContentProps {
  unverifiedBadgeCount: number;
  onClockIn: () => void;
  onViewBadgePolicy: () => void;
}

export function SkippedBadgeVerificationContent(props: SkippedBadgeVerificationContentProps) {
  const { unverifiedBadgeCount, onClockIn, onViewBadgePolicy } = props;

  return (
    <Stack
      sx={(theme) => ({
        height: "100%",
        background: theme.palette.shift?.badgeSkippedWarning.gradient,
      })}
    >
      <DialogContent
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Stack spacing={12} alignItems="center" sx={{ textAlign: "center" }}>
          <Title component="h1" variant="h2" sx={(theme) => ({ color: theme.palette.error.light })}>
            You have skipped badge verification
          </Title>

          <UnverifiedBadgeCounter isError unverifiedBadgeCount={unverifiedBadgeCount} />

          <Text variant="body1" color={(theme) => theme.palette.text.secondary}>
            Order a badge from your account page to be ready for the next badge-required shift.
          </Text>
        </Stack>
      </DialogContent>

      <DialogFooter orientation="vertical">
        <Button fullWidth variant="contained" size="large" onClick={onClockIn}>
          Clock in
        </Button>
        <Button fullWidth variant="text" size="large" onClick={onViewBadgePolicy}>
          View badge policy
        </Button>
      </DialogFooter>
    </Stack>
  );
}
